import Modal from "../Modal"
import {createUseStyles} from 'react-jss'
import {useEffect, useState} from "react"
import {PayrollFileRow} from "../../redux/types"
import PayrollFileRowList from "./PayrollFileRowList"
import {useTranslation} from "react-i18next"
import usePayrollActions from "../../hooks/usePayrollActions";
import ConfirmModal from "../ConfirmModal";
import { Spinner } from 'react-bootstrap'

interface Props {
  visible: boolean
  rows: PayrollFileRow[]
  onCloseClick: () => void
}

const PayrollFileRowsModal = ({visible, rows, onCloseClick}: Props) => {
  const styles = useStyles()
  const {t} = useTranslation(['common', 'payrolls']);
  const {deletePayrollFileRow} = usePayrollActions()
  const [pageIndex, setPageIndex] = useState<number>(1)
  const [deleteCandidate, setDeleteCandidate] = useState<PayrollFileRow | undefined>()
  const [confirmDeleteModalVisible, setConfirmDeleteModalVisible] = useState(false)
  const [isDeleting, setIsDeleting] = useState(false)

  useEffect(() => {
    setPageIndex(1)
  }, [rows])

  const confirmDeleteRow = (row: PayrollFileRow) => {
    setDeleteCandidate(row)
    setConfirmDeleteModalVisible(true)
  }

  const handleDeleteConfirmed = async () => {
    if (deleteCandidate) {
      setConfirmDeleteModalVisible(false)
      setIsDeleting(true)
      try {
        await deletePayrollFileRow(deleteCandidate.id)
      } finally {
        setIsDeleting(false)
        setDeleteCandidate(undefined)
      }
    }
  }

  return (
    <>
      <Modal
        size={'lg'}
        title={t('payrollFileContent', {ns: 'payrolls'})}
        visible={visible}
        okButtonTitle={t('close', {ns: 'common'})}
        hideCancelButton={true}
        onHide={onCloseClick}
        onOkClick={onCloseClick}
        onCancelClick={onCloseClick}
      >
        {isDeleting && (
          <div className={styles.loadingOverlay}>
            <Spinner animation="border" />
            <div className={styles.loadingText}>{t('deleting', {ns: 'common'})}</div>
          </div>
        )}
        <div className={styles.container}>
          <PayrollFileRowList
            pageIndex={pageIndex}
            pageSize={15}
            rows={rows}
            onPageChange={(pageIndex: number) => setPageIndex(pageIndex)}
            onDeleteRow={(row) => confirmDeleteRow(row)}
          />
        </div>
      </Modal>
      <ConfirmModal
        visible={confirmDeleteModalVisible}
        confirmText={t('confirmDeleteRow', {ns: 'payrolls'})}
        onConfirmClick={handleDeleteConfirmed}
        onCancelClick={() => setConfirmDeleteModalVisible(false)}
      />
    </>
  )
}

export default PayrollFileRowsModal

const useStyles = createUseStyles({
  container: {
    display: 'flex',
    flex: 1,
    flexDirection: 'column'
  },
  loadingOverlay: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(255, 255, 255, 0.7)',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 1000
  },
  loadingText: {
    marginTop: 10,
    fontWeight: 'bold'
  }
})
